import React from 'react'
import { RowLayout } from '../RowLayout'
import { CostRespType, TreatmentType } from '../../models'
import { priceFormat } from '../../helpers/miscFunctions'
import { strToDateFormat } from '../../helpers'
import { translation } from '../../i18n'

export type treatmentExpensesOverview = {
  treatmentType: TreatmentType
  cost: CostRespType
} & translation

export const TreatmentExpensesOverview = (
  params: treatmentExpensesOverview
) => {
  const t = params.t
  return (
    <>
      <RowLayout
        text={t('forthPg.costDate.label')}
        data={strToDateFormat(params.cost.costDate)}
      />
      <RowLayout
        text={t('forthPg.amount.label')}
        data={priceFormat({
          price: params.cost.amount,
          currency: params.cost.currency,
        })}
      />
      <RowLayout
        text={t('forthPg.expenseType.label')}
        data={t(`treatmentExpensesType.${params.treatmentType}.${params.cost.expenseType}`)}
      />
      <RowLayout
        text={t('forthPg.paidDirectly.label')}
        data={params.cost.paidDirectly ? t('yes') : t('no')}
      />
    </>
  )
}
